import React, { useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiPresetCards from "../../shared/Popup/AiPresetCards";
import { presetTip } from "../../shared/Popup/presetTip";

const STRENGTHS = [
  {
    id: "subtle",
    label: "Subtle",
    sub: "Light cleanup",
    tip: presetTip('Subtle — "Light cleanup"', [
      "Softens mild cast shadows",
      "Keeps most of the original lighting",
    ]),
  },
  {
    id: "balanced",
    label: "Balanced",
    sub: "Recommended",
    tip: presetTip('Balanced — "Recommended"', [
      "Removes common product and face shadows",
      "Good default for most photos",
    ]),
  },
  {
    id: "strong",
    label: "Strong",
    sub: "Deep clean",
    tip: presetTip('Strong — "Deep clean"', [
      "Aggressive shadow flattening",
      "Best for heavy or uneven shadows",
    ]),
  },
];

/**
 * AI Tools → AI Shadow Remover prep.
 */
const ShadowRemoverToolPrep = (props) => {
  const [strengthId, setStrengthId] = useState("balanced");
  const [prompt, setPrompt] = useState("");

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_shadow_remover"
      title="AI Shadow Remover"
      aka="Shadow Cleaner"
      bio="Clean unwanted shadows and even out the lighting."
      emptyPreviewLabel="Upload an image to preview shadow removal"
      loadingLabel="Removing shadows…"
      emptyFooterHint="Upload an image, pick strength, then generate."
      renderControls={({ busy, leftPanelRef }) => (
        <>
          <div className="aftp-section">
            <p className="aftp-label">Strength</p>
            <AiPresetCards
              presets={STRENGTHS}
              selectedId={strengthId}
              ariaLabel="Shadow remove strength"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setStrengthId(id);
              }}
            />
          </div>
          <div className="aftp-section">
            <label className="aftp-label" htmlFor="aftp-sr-prompt">
              Focus area <span className="aftp-optional">(optional)</span>
            </label>
            <textarea
              id="aftp-sr-prompt"
              className="aftp-input"
              rows={3}
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              placeholder="e.g. shadow under the product, face cast shadow"
              disabled={busy}
            />
          </div>
        </>
      )}
    />
  );
};

export default ShadowRemoverToolPrep;
